<template>
  <v-row no-gutters>
    <v-col cols="12" class="d-flex justify-center">
      <v-icon>mdi-arrow-down</v-icon>
    </v-col>
    <v-col cols="12" class="d-flex justify-center">
      <v-card @click="actionSelect" min-width="180" max-width="250">
        <h4 class="pa-3">
          <v-icon v-text="actionIcon" class="mr-2"></v-icon>
          {{ value.actionType }}
        </h4>
        <v-divider v-if="value.description"></v-divider>
        <div v-if="value.desc" class="pa-3">
          {{ value.desc }}
        </div>
      </v-card>
    </v-col>
    <v-col v-if="value.childAction1 && value.childAction2" cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex justify-center">
          <v-icon>mdi-arrow-down</v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6" offset="3">
          <div style="height: 2px; background-color: #c0c0c0"></div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6" class="d-flex justify-center">
          <v-chip color="success"
            ><v-icon dark x-small>mdi-check</v-icon></v-chip
          >
        </v-col>
        <v-col cols="6" class="d-flex justify-center">
          <v-chip color="error">
            <v-icon dark x-small>mdi-close</v-icon>
          </v-chip>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6" v-if="value.childAction1">
          <WorkflowAction
            v-for="(action, index) in value.childAction1"
            :key="index"
            :value="action"
            :actions="value.childAction1"
            :types="types"
            @action-select="childActionSelect"
          />
          <NewActionDialog
            v-if="
              value.childAction1.length == 0 ||
              !value.childAction1[value.childAction1.length - 1].childAction1
            "
            :actions="value.childAction1"
            :types="types"
            class="d-flex justify-center"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="primary" @click="on">
                <v-icon>mdi-plus</v-icon> เพิ่ม
              </v-btn>
            </template>
          </NewActionDialog>
        </v-col>
        <v-col cols="6" v-if="value.childAction2">
          <WorkflowAction
            v-for="(action, index) in value.childAction2"
            :key="index"
            :value="action"
            :actions="value.childAction2"
            :types="types"
            @action-select="childActionSelect"
          />
          <NewActionDialog
            v-if="
              value.childAction2.length == 0 ||
              !value.childAction2[value.childAction2.length - 1].childAction1
            "
            :actions="value.childAction2"
            :types="types"
            class="d-flex justify-center"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="primary" @click="on">
                <v-icon>mdi-plus</v-icon> เพิ่ม
              </v-btn>
            </template>
          </NewActionDialog>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import NewActionDialog from "./NewActionDialog.vue";

export default {
  name: "WorkflowAction",

  components: { NewActionDialog },

  props: ["value", "actions", "types"],

  computed: {
    actionIcon() {
      const t = this.getType(this.value.actionType);
      if (t) return t.icon;
      else return "mdi-cog-outline";
    },
  },

  methods: {
    getType(name) {
      for (let i = 0; i < this.types.length; i++) {
        for (let j = 0; j < this.types[i].types.length; j++) {
          const t = this.types[i].types[j];
          if (name == t.name) {
            return t;
          }
        }
      }

      return null;
    },
    actionSelect() {
      this.$emit("action-select", {
        selection: this.value,
        actions: this.actions,
      });
    },
    childActionSelect(params) {
      this.$emit("action-select", params);
    },
  },
};
</script>

<style>
</style>